import { useMemo } from 'react';
import { useApplicationDispatch, useApplicationSelector } from '../../../../../Redux/ReduxStore';
import { selectValueMatrixTableInputsRequest, setValueMatrixTableInputsRequest } from '../../../../../Redux/Slices/ValueMatrixCalculatorSlice';
import useSymbolsApi from '../../../../Apis/Hooks/useSymbolsApiHook';
import Dropdown from '../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import styles from '../ValueMatrixCalculator.module.scss';

type SymbolCategoryOption = { label: string; value: string };

const ValueMatrixMarketDropdown: React.FC = () => {
    const [translations, translate] = useLanguage();
    const symbols = useSymbolsApi();
    const dispatch = useApplicationDispatch();
    const valueMatrixTableInputs = useApplicationSelector(selectValueMatrixTableInputsRequest);

    const marketOptions = useMemo(() => {
        if (!symbols) {
            return [];
        }

        // Create a list of unique categories.
        const symbolCategoryOptions: SymbolCategoryOption[] = [];
        symbols.forEach((x) => {
            if (symbolCategoryOptions.map((y) => y.value).includes(x.symbolCategory)) {
                return;
            }

            symbolCategoryOptions.push({
                label: translate(x.symbolCategory),
                value: x.symbolCategory,
            });
        });

        return symbolCategoryOptions;
    }, [translations, symbols]);

    return (
        <div className={styles.value_matrix_dropdown}>
            <Dropdown
                testId="ValueMatrixMarketDropdown"
                value={valueMatrixTableInputs.market}
                options={marketOptions}
                handleOptionChange={(value) => {
                    dispatch(
                        setValueMatrixTableInputsRequest({
                            ...valueMatrixTableInputs,
                            market: value,
                            isCascadeUpdating: true,
                        }),
                    );
                }}
                label={translations.calculators.valueMatrix.fields.sector}
                track={{ eventCategory: 'ValueMatrixCalculator', eventAction: 'SectorChanged' }}
            />
        </div>
    );
};

export default ValueMatrixMarketDropdown;
